/**
 * Frontend plan tier constants — mirrors PlanTier.kt on the backend.
 * Use these instead of raw strings anywhere plan tiers or features are referenced.
 */

export const PlanTier = Object.freeze({
  STARTER: 'starter',
  SKILLED: 'skilled',
})

export const PlanFeature = Object.freeze({
  FLOWLY_AI: 'FLOWLY_AI',
  ADVANCED_ALERTS: 'ADVANCED_ALERTS',
})

/** Human-readable display names by tier key */
export const TIER_DISPLAY_NAMES = Object.freeze({
  [PlanTier.STARTER]: 'Starter',
  [PlanTier.SKILLED]: 'Skilled',
})

/**
 * Feature display metadata.
 * `comingSoon: true` renders a "coming soon" badge in all tier UI components.
 * Flip to false here when a feature ships.
 */
export const FEATURE_META = Object.freeze({
  [PlanFeature.FLOWLY_AI]: { label: 'Flowly AI', comingSoon: false },
  [PlanFeature.ADVANCED_ALERTS]: { label: 'Advanced Alerts', comingSoon: true },
})

/**
 * Stripe price ID → display name mapping.
 * Used in BillingPage to render a friendly plan name from the stored price ID.
 */
export const PLAN_NAMES = Object.freeze({
  // Starter Weekly price ID
  price_1UB24zBEFcqZwEZFJ8hnRfjb: 'CapitalFlow Starter',
  // Legacy Starter price IDs
  price_1KunZUBEFcqZwEZFTmiPEMmO: 'CapitalFlow Starter',
  price_1OWmVgBEFcqZwEZFUatsGCl1: 'CapitalFlow Starter',
  price_1KvAmCBEFcqZwEZFyT81Lpi7: 'CapitalFlow Starter',
  price_1QgmqGBEFcqZwEZFGEK0Wy9m: 'CapitalFlow Starter',
  price_1QgmrQBEFcqZwEZFfpOHOPKa: 'CapitalFlow Starter',
  // Current Starter price IDs
  price_1TmcDgBEFcqZwEZFUb1OMB2D: 'CapitalFlow Starter',
  price_1TmcWmBEFcqZwEZF9k84JbM7: 'CapitalFlow Starter',
  price_1TssLxBEFcqZwEZFbdRnuKwN: 'CapitalFlow Starter',
  // Skilled price IDs
  price_1TssLPBEFcqZwEZFsBfpl9UH: 'CapitalFlow Skilled',
  price_1TssMDBEFcqZwEZFG0PT8VGU: 'CapitalFlow Skilled',
})
